import { useState } from "react";
import { Send, Loader2 } from "lucide-react";
import axios from "axios";
import { API } from "./constants";

export const ProjectComments = ({ projectId, comments, onRefresh }) => {
  const [text, setText] = useState("");
  const [posting, setPosting] = useState(false);

  const post = async () => {
    if (!text.trim() || posting) return;
    setPosting(true);
    try {
      await axios.post(`${API}/projects/${projectId}/comments`, { content: text.trim() }, { withCredentials: true });
      setText("");
      onRefresh();
    } catch (e) { console.error(e); }
    finally { setPosting(false); }
  };

  return (
    <div className="p-6" data-testid="comments-tab">
      <div className="flex items-start gap-3 mb-4">
        <div className="w-7 h-7 rounded-full bg-gradient-to-br from-[#014d7d] to-[#178a55] flex items-center justify-center text-white text-[9px] font-bold shrink-0">A</div>
        <div className="flex-1 border border-border/50 rounded-xl overflow-hidden bg-white">
          <textarea value={text} onChange={e => setText(e.target.value)}
            placeholder="Add a comment..." className="w-full px-4 py-3 text-sm outline-none resize-none bg-transparent placeholder:text-foreground/45" rows={2} data-testid="comment-input" />
          <div className="flex items-center justify-end px-3 py-2 border-t border-border/30 bg-[#f8f9fb]">
            <button onClick={post} disabled={!text.trim() || posting}
              className="text-xs font-semibold px-4 py-1.5 rounded-lg bg-[#014d7d] text-white disabled:opacity-40 flex items-center gap-1.5" data-testid="post-comment-btn">
              <Send className="w-3 h-3" /> Post
            </button>
          </div>
        </div>
      </div>
      <div className="space-y-3">
        {comments?.map(c => (
          <div key={c.id} className="flex items-start gap-3">
            <div className="w-6 h-6 rounded-full flex items-center justify-center text-white text-[8px] font-bold shrink-0" style={{ background: c.author?.color || "#999" }}>{c.author?.initials}</div>
            <div className="flex-1 bg-white border border-border/50 rounded-xl px-4 py-3">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-xs font-semibold text-foreground">{c.author?.name}</span>
                <span className="text-[10px] text-foreground/45">{new Date(c.created_at).toLocaleString()}</span>
              </div>
              <p className="text-xs text-foreground/60 leading-relaxed">{c.content}</p>
            </div>
          </div>
        ))}
        {comments.length === 0 && <p className="text-center text-foreground/45 py-8 text-sm">No comments yet</p>}
      </div>
    </div>
  );
};
